import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var PartExIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M14.03.47a.75.75 0 0 1 0 1.06l-1.242 1.243c4.868.34 8.712 4.397 8.712 9.352a9.352 9.352 0 0 1-2.989 6.864.75.75 0 0 1-1.022-1.098 7.876 7.876 0 0 0-4.646-13.608L14.03 5.47a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM10.47 23.53a.75.75 0 0 1 0-1.06l.992-.993c-4.868-.34-8.712-4.397-8.712-9.352a9.351 9.351 0 0 1 2.96-6.837.75.75 0 1 1 1.027 1.094 7.875 7.875 0 0 0 5.2 13.616L10.47 18.53a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0Z"
        })
    }));
};
